import axios from "axios";
import React from "react";

const handleInputType = (inputType) => {
    if (!!inputType) {
        switch (inputType) {
            case "email":
                return "email";
            case "tel-phone":
            case "mobile-phone":
                return "number";
            case "diff_address":
                return "checkbox";
            default:
                return "text";
        }
    }
};

const handleLocalStorageData = (newState, modelsData) => {
    // Check if we need to use modelsData or modelsDataQuotation
    const localStorageData = JSON.parse(window.localStorage.getItem(modelsData));
    if (!!localStorageData && localStorageData.length > 0) {
        localStorageData[0].data = newState[0].data;
        window.localStorage.setItem(modelsData, JSON.stringify(localStorageData));
    }
};

const showFormLabel = (e) => {
    const getLabelFromInput = e.target.parentElement.querySelector("label");
    if (getLabelFromInput) {
        getLabelFromInput.classList.toggle("hide-label", e.target.value === "");
    }
};

const isEU = (country) => {
    if (typeof country === "undefined" || country === null) {
        return false;
    }

    const euCountries = [
        "Austria",
        "Belgium",
        "Bulgaria",
        "Croatia",
        "Cyprus",
        "Czech Republic",
        "Denmark",
        "Estonia",
        "Finland",
        "France",
        "Germany",
        "Greece",
        "Hungary",
        "Ireland",
        "Italy",
        "Latvia",
        "Lithuania",
        "Luxembourg",
        "Malta",
        "Netherlands",
        "Poland",
        "Portugal",
        "Romania",
        "Slovakia",
        "Slovenia",
        "Spain",
        "Sweden",
        "Liechtenstein",
    ];

    return euCountries.includes(country);
};

const getCurrentLabel = async () => {
    // check if the label id is already cached
    let label_id = window.localStorage.getItem("label_id");
    if (label_id !== null) {
        return label_id;
    }

    let response = await axios.get(window.location.origin + "/api/which-label");
    // cache the label id\
    if (response?.data?.label_id !== undefined && response?.data?.label_id !== null) {
        window.localStorage.setItem("label_id", response.data.label_id);
        window.localStorage.setItem("label_name", response.data.object?.name);
    }

    return response.data?.label_id;
};

const apiLabelUrl = async (type) => {
    let chosenType;
    let currentDomain = window.location.hostname;
    let httpOrHttps = window.location.protocol;
    let currentUrl = `${httpOrHttps}//${currentDomain}`;
    switch (type) {
        case "web":
            chosenType = currentUrl;
            break;
        case "api":
            chosenType = currentUrl + "/api";
            break;
        default:
            chosenType = currentUrl;
    }

    const baseUrl = chosenType;
    const labelId = await getCurrentLabel();
    return `${baseUrl}/${labelId}`;
};
export { handleInputType, showFormLabel, handleLocalStorageData, isEU, apiLabelUrl, getCurrentLabel };
